<template>
    <v-app-bar fixed app :clipped-left="clipped" color="white" elevation="0"
        style="border-bottom: 1px solid #ececec !important">
        <v-app-bar-nav-icon @click="updateDrawer"></v-app-bar-nav-icon>
        <!-- <v-toolbar-title>{{ currentRoute }}</v-toolbar-title> -->

        <v-breadcrumbs>
            {{ currentRoute }}
        </v-breadcrumbs>
        <v-spacer></v-spacer>

        <v-divider vertical class="mx-1"></v-divider>
        <v-menu anchor="bottom end">
            <template v-slot:activator="{ props }">
                <v-btn prepend-icon="mdi-account-circle" append-icon="mdi-menu-down" v-bind="props">
                </v-btn>
            </template>
            <v-list>
                <!-- <v-list-item link title="Profile" @click="toggleModel()">
                </v-list-item>
                <v-divider></v-divider> -->
                <v-list-item link title="" >
                    {{ currentUser.user }}
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item link title="Change Password" @click="toggleModelPassword()">
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item link title="Logout" @click.prevent="logOut">
                </v-list-item>
            </v-list>

        </v-menu>
    </v-app-bar>
    <div v-if="addModal">
        <ChangeProfile @close-modal="toggleModel" :id="currentId" />
    </div>
    <div v-if="addModalPassword">
        <ChangePassword @close-modal="toggleModelPassword" :id="currentId" />
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import ChangeProfile from "../views/userProfile/ChangeProfile.vue";
import ChangePassword from "../views/userProfile/ChangePassword.vue";


export default {
    name: 'Header',
    data: () => ({
        addModal: false,
        addModalPassword: false,
        clipped: false,
        mini: false,
        show: false,
        connected_cli_switch: true,
        model: 0,
        list_apps: 0,
    }),
    computed: {
        currentUser() {

            return this.$store.state.auth.user;
        },
        currentRoute() {
            return this.$route.name;
        },

    },
    components: {
        ChangeProfile,
        ChangePassword,
    },
    methods: {
        logOut() {
            localStorage.removeItem('user');
            this.$store.dispatch('auth/logout');
            this.$router.push('/'+localStorage.getItem('encodedHotspotId'));
        },
        updateDrawer() {
            this.$store.dispatch('theme/updateDrawer');
        },
        toggleModel() {
            this.addModal = !this.addModal;
        },
        toggleModelPassword() {
            this.addModalPassword = !this.addModalPassword;
        },
        switchBackUser(item) {
            this.$store.dispatch('swithUser/removeSwitchUser', item);
            this.$router.push('/dashboard');

        }
    },
}


</script>